<template>
  <textarea
    v-if="stepActive.text_size === 'long'"
    class="klickbox-step-input-edit"
    v-model="placeholderText"
    rows="5"></textarea>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    placeholderText: 'stepTextPlaceholder',
    stepActive: 'stepActive',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Textarea.vue?5bab3563
 **/